import React from 'react';

function Secretary() {
  return (
    <section id="secretary" className="leader-section leader-section--light">
      <div className="section-container">
        <div className="section-title-block">
          <h2 className="section-title">
             Message from the Secretary
          </h2>
          <div className="gold-underline"></div>
        </div>
        <div className="leader-content">
          <div className="leader-image-col">
            <div className="leader-photo-frame">
              <img src="/secretary.jpg" alt="Secretary Mrs. Shylaja" className="leader-photo" />
            </div>
            <div className="leader-id-card">
              <h3>Mrs. Shylaja</h3>
              <p className="leader-title-tag">Secretary</p>
              <p className="leader-college-tag">Paramananda College of Nursing</p>
              <p className="leader-location-tag">📍 Bengaluru, Karnataka</p>
            </div>
          </div>
          <div className="leader-message-col">
            <div className="leader-quote-icon">"</div>
            <blockquote>
              Education is the most powerful tool we can give to shape the future of healthcare.
              At Paramananda College of Nursing, we believe every student carries the potential to
              become a transformational force in the lives of patients and communities.
            </blockquote>
            <p>
              Our commitment extends beyond academic excellence. We invest in the holistic development
              of every student — nurturing empathy, clinical confidence, ethical practice, and leadership.
              We ensure that when our graduates step into hospitals and clinics, they do so with both
              the knowledge and the heart of a true caregiver.
            </p>
            <p>
              Join us and be a part of a legacy of compassion, service, and excellence that
              Paramananda College of Nursing has built over the years.
            </p>
            <div className="leader-btns">
              <button className="btn btn-primary">Read Full Message</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Secretary;
